

































import {Component, Prop, Vue} from "vue-property-decorator";
import {DivisionPickupStore} from "../../store";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import {EmployeeType, PartnerType, SiteTargetType} from "@/enums/type";
import PartnerSelector from "@/shared/components/PartnerSelector/index.vue";
import {DivisionPickupStatus} from "@/enums/status";
import {DivisionPickup} from "@/interfaces/entity";

@Component({
    name: "DivisionPickupTableAction",
    components: {PartnerSelector, EmployeeSelector}
})
export default class extends Vue {
    @Prop({ required: true}) readonly pickupId!: string;
    PartnerType = PartnerType;
    SiteTargetType = SiteTargetType;
    EmployeeType = EmployeeType;
    targetType = SiteTargetType.Employee;
    private form = {
        receiveTargetRowGuid : undefined,
        receiveTargetType: SiteTargetType.Employee,
        divisionPickupId: undefined
    }
    visible = false;
    get pickup(): DivisionPickup {
        return DivisionPickupStore.data[this.pickupId];
    }
    
    set pickup(value: DivisionPickup) {
        DivisionPickupStore.data[this.pickupId] = value;
    }
    
    mounted() {
        this.form.receiveTargetRowGuid = this.pickup.receiveTargetRowGuid as any
        this.form.divisionPickupId = this.pickup.id as any
    }
    
    async createPickup() {
        try {
            await DivisionPickupStore.createDivisionPickup(this.form);
            this.$notification.success({
                message: "Thành công",
                description: "Phân mới shipper thành công"
            });
            this.visible = false
            DivisionPickupStore.data[this.pickupId] = {...this.pickup, status: DivisionPickupStatus.DaPhanLai}
        } catch (e) {
            console.log(e)
            this.$notification.error({
                message: "Thất bại",
                description: `${e.response?.data?.message || "Phân mới shipper thất bại"}`
            })
        }
    }
    
    onchangeTargetType() {
        if (this.form.receiveTargetType) {
            this.form.receiveTargetRowGuid = undefined;
            this.form.receiveTargetType = this.targetType;
        }
    }
}
